export default {
    NAVIGATION: "_setNavigation",
    HEADER: "_setHeader",
    ANIMATION: "_setAnimations",
    SPEAKER: "_setSpeaker",
    MODAL: "_setModal",
}